import { BioSampleCode, BioSampleId } from '@csp/csp-common-hbs-model';
import { useHbsSearchParams } from '../../hbs/hook/useHbsSearchParams';
import { HbsSearchParamKey } from '../../hbs/type/HbsSearchParamKey';
import { BioSampleDetailsNavigation, OpenBioSampleDetailsIn } from '../model/BioSampleDetailsNavigation';

type BioSampleDetailsNavigationSearchParams = {
  [HbsSearchParamKey.SAMPLE_CODE]?: BioSampleCode;
  [HbsSearchParamKey.SAMPLE_ID]?: BioSampleId;
};

export const useBioSampleDetailsNavigation = (): BioSampleDetailsNavigation => {
  const { setSearchParams, clearSearchParams } = useHbsSearchParams();

  const open = ({ sampleId, sampleCode }: OpenBioSampleDetailsIn): void => {
    const searchParams: BioSampleDetailsNavigationSearchParams = {};
    if (sampleId) {
      searchParams[HbsSearchParamKey.SAMPLE_ID] = sampleId;
    }
    if (sampleCode) {
      searchParams[HbsSearchParamKey.SAMPLE_CODE] = sampleCode;
    }
    setSearchParams(searchParams);
  };

  const close = (): void => {
    clearSearchParams([HbsSearchParamKey.SAMPLE_ID, HbsSearchParamKey.SAMPLE_CODE]);
  };

  return {
    open,
    close,
  };
};
